import type { QueryClient } from '@tanstack/react-query';

export const invalidateTeamAccessQueries = (queryClient: QueryClient, teamId?: string) => {
  if (teamId) queryClient.invalidateQueries({ queryKey: ['team-members', teamId] });
  queryClient.invalidateQueries({ queryKey: ['teams'] });
  queryClient.invalidateQueries({ queryKey: ['admin-teams'] });
  queryClient.invalidateQueries({ queryKey: ['projects'] });
  queryClient.invalidateQueries({ queryKey: ['agents'] });
  queryClient.invalidateQueries({ queryKey: ['prompts'] });
};

export const invalidateProjectAccessQueries = (queryClient: QueryClient, projectId?: string) => {
  if (projectId) {
    queryClient.invalidateQueries({ queryKey: ['project-members', projectId] });
    queryClient.invalidateQueries({ queryKey: ['project-teams', projectId] });
    queryClient.invalidateQueries({ queryKey: ['project', projectId] });
    queryClient.invalidateQueries({ queryKey: ['project-full', projectId] });
  }
  queryClient.invalidateQueries({ queryKey: ['projects'] });
  queryClient.invalidateQueries({ queryKey: ['agents'] });
  queryClient.invalidateQueries({ queryKey: ['prompts'] });
};

export const invalidateResourceAccessQueries = (
  queryClient: QueryClient,
  type: 'prompt' | 'agent',
  resourceId?: string,
) => {
  if (resourceId) {
    queryClient.invalidateQueries({ queryKey: [type === 'prompt' ? 'prompt-permissions' : 'agent-permissions', resourceId] });
  }
  queryClient.invalidateQueries({ queryKey: [type === 'prompt' ? 'prompts' : 'agents'] });
};